// extracted by mini-css-extract-plugin
export var numpadContainer = "_sc-1";
export var phoneButton = "_sc-0";